import { LocaleCodeMap } from '@doss/common-all'
import { useField, useFormikContext } from 'formik'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import {
  NumberFormatFields,
  NumberFormatValue,
} from '~/components/number-format/NumberFormatFields'
import { ColumnFormValues } from './types'

/**
 * Formik adapter for table column number formatting. Bridges the shared, form-library-agnostic
 * {@link NumberFormatFields} to Formik's `formatPreset`/`formatOptions` fields.
 */
export const NumberFormatSection = () => {
  const { user } = useGlobalContext()
  const orgCurrency = user?.organizationCurrency ?? undefined
  const orgLocale = user?.organizationLocale ? LocaleCodeMap[user.organizationLocale] : undefined
  const formik = useFormikContext<ColumnFormValues>()
  const [, unitMetadata] = useField<string | undefined>('formatOptions.unit')
  const [, decimalPlacesMetadata] = useField<number | undefined>('formatOptions.decimalPlaces')

  const onChange = ({ formatPreset, formatOptions }: NumberFormatValue) => {
    formik.setValues((current) => ({ ...current, formatPreset, formatOptions }))
  }

  return (
    <NumberFormatFields
      errors={{
        unit: unitMetadata.touched ? unitMetadata.error : undefined,
        decimalPlaces: decimalPlacesMetadata.touched ? decimalPlacesMetadata.error : undefined,
      }}
      formatOptions={formik.values.formatOptions}
      formatPreset={formik.values.formatPreset}
      onBlurField={(field) => formik.setFieldTouched(`formatOptions.${field}`, true)}
      onChange={onChange}
      orgCurrency={orgCurrency}
      orgLocale={orgLocale}
    />
  )
}
